<template>
  <v-layout row>
    <v-flex 
      sm12 
      md8 
      offset-md2
      xl6
      offset-xl3>
      <v-card>
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>Administrators</v-toolbar-title>
        </v-toolbar>
        <v-card-title>
          <v-dialog 
            v-model="dialog" 
            max-width="500px">
            <v-btn 
              slot="activator" 
              color="secondary darken-2" 
              dark 
              class="mb-2">Add administrator</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">Add administrator</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form 
                    ref="form" 
                    v-model="valid"                 
                    lazy-validation>
                    <v-layout wrap>
                      <v-flex 
                        xs12 
                        sm6>
                        <v-text-field 
                          v-model="newUser.username" 
                          :rules="[
                            v => !!v || 'Username is required',
                            v => !v || v.length <= 14 || 'Username must be under 15 characters',
                            v => !v || v.length >= 2 || 'Username must be at least 2 characters',
                            v => /^[a-z]{2,14}$/.test(v) || 'Username expects lowercase letters only'
                          ]"
                          required
                          label="Username"/>
                      </v-flex>
                      <v-flex 
                        xs12 
                        sm6>
                        <v-text-field 
                          v-model="newUser.fullname" 
                          :rules="[
                            v => !!v || 'Full name is required',
                            v => !v || v.length <= 100 || 'Full name must be less than 100 characters',
                          ]"
                          required
                          label="Full name"/>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn 
                  color="blue darken-1" 
                  flat 
                  @click.native="close">Cancel</v-btn>
                <v-btn 
                  color="blue darken-1" 
                  flat 
                  @click.native="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="administrators"
          :search="search"
          :rows-per-page-items="[10,25,50,{'text':'All','value':-1}]"
          must-sort>
          <template 
            slot="items" 
            slot-scope="props">
            <td>{{ props.item.username }}</td>
            <td>{{ props.item.fullname }}</td>
            <td>{{ props.item.createdAt.seconds | moment("calendar") }}</td>
            <td class="justify-center layout px-0">
              <v-btn 
                color="red darken-1"
                icon 
                flat
                @click.prevent="deleteDialog(props.item)"><v-icon>delete</v-icon></v-btn>
            </td>
          </template>
          <v-alert 
            slot="no-results" 
            :value="true" 
            color="error" 
            icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
    <v-dialog 
      v-if="selectedUser" 
      v-model="confirm"
      persistent 
      max-width="290">
      
      <v-card>
        <v-card-title class="headline">Delete {{ selectedUser.username }}</v-card-title>
        <v-card-text>{{ selectedUser.fullname }} will no longer have administrator access.</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="blue darken-1" 
            flat 
            @click.native="confirm = false">Close</v-btn>
          <v-btn 
            color="red darken-1" 
            flat 
            @click.native="remove(selectedUser)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: "Users",
  data: () => ({
    dialog: false,
    confirm: false,
    valid: true,
    search: "",
    headers: [
      { text: "Username", value: "username" },
      { text: "Fullname", value: "fullname" },
      { text: "Date added", value: "createdAt" },
      { text: "Actions", value: "name", sortable: false }
    ],
    administrators: null,
    newUser: {
      username: null,
      fullname: null
    },
    selectedUser: null
  }),
  firestore() {
    return {
      administrators: this.$store.getters.db
        .collection("roles/admin/users")
        .orderBy("username")
    };
  },

  methods: {
    deleteDialog(selected) {
      this.selectedUser = selected;
      this.confirm = true;
    },
    save() {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        this.$store.dispatch("setLoading", false);
        let createdAt = new Date();
        this.$store.getters.db
          .collection("roles/admin/users")
          .doc(this.newUser.username)
          .set({ ...this.newUser, createdAt })
          .then(function() {
            console.log("Document successfully written!");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "success",
              timeout: 6000,
              text: "User " + self.newUser.username + " added"
            });
            // self.$store.dispatch('setLoading', false)
            self.$refs.form.reset();
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
            // self.$store.dispatch('setLoading', false)
            self.$refs.form.reset();
          });
      }
    },
    remove(item) {
      let self = this;
      this.confirm = false;
      this.$store.dispatch("setLoading", true);
      this.$store.getters.db
        .collection("roles/admin/users")
        .doc(item[".key"])
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          self.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "error",
            timeout: 6000,
            text: item.username + " removed"
          });
          self.$store.dispatch("setLoading", false);
          self.selectedUser = null;
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
          self.$store.dispatch("setLoading", false);
        });
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
    }
  }
};
</script>
